import { c as _c } from "react/compiler-runtime";
import { pageRoute, type PageRouteValue } from 'shared/constants/routes.constants';
import { type PagePermissions, usePermission } from 'shared/hooks/use-permission';
import { getPageRoute } from 'shared/utils/get-dynamic-page-route';
type StaticPageRouteValue = Exclude<PageRouteValue, `${string}[${string}`>;
const isStaticPageRoute = (route: PageRouteValue): route is StaticPageRouteValue => {
  return !route.includes('[');
};
const firstAvailableRoutePriority: StaticPageRouteValue[] = [pageRoute.Dashboard, pageRoute.Funnels, pageRoute.AffiliateDashboard];
const getFirstAvailableRoute = (pagePermissions: PagePermissions) => {
  const restRoutes = Object.values(pageRoute).filter(isStaticPageRoute).filter(route => !firstAvailableRoutePriority.includes(route));
  const routePriority: StaticPageRouteValue[] = [...firstAvailableRoutePriority, ...restRoutes];
  return routePriority.find(route => pagePermissions[route]) ?? pageRoute.Forbidden;
};
export const useFirstAvailableRoute = () => {
  const $ = _c(4);
  const {
    pagePermissions
  } = usePermission();
  let t0;
  if ($[0] !== pagePermissions) {
    t0 = getPageRoute(getFirstAvailableRoute(pagePermissions));
    $[0] = pagePermissions;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== t0) {
    t1 = {
      firstAvailableRoute: t0
    };
    $[2] = t0;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  return t1;
};